var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgMyHub = function SvgMyHub(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#my-hub_svg__clip0_1614_19500)",
    fill: "#333"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.833 1.25c0-.23.187-.417.417-.417h7.083V0H1.25C.56 0 0 .56 0 1.25v7.083h.833V1.25zM.833 18.75v-7.083H0v7.083C0 19.44.56 20 1.25 20h7.083v-.833H1.25a.417.417 0 01-.417-.417zM19.167 18.75c0 .23-.187.417-.417.417h-7.083V20h7.083c.69 0 1.25-.56 1.25-1.25v-7.083h-.833v7.083zM18.75 0h-7.083v.833h7.083c.23 0 .417.187.417.417v7.083H20V1.25C20 .56 19.44 0 18.75 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.333 2.5h-5a.833.833 0 00-.833.833v5c0 .46.373.834.833.834h5c.46 0 .834-.373.834-.834v-5a.833.833 0 00-.834-.833zm0 5.833h-5v-5h5v5zM8.333 10.833h-5a.833.833 0 00-.833.834v5c0 .46.373.833.833.833h5c.46 0 .834-.373.834-.833v-5a.833.833 0 00-.834-.834zm0 5.834h-5v-5h5v5zM11.667 9.167h5c.46 0 .833-.373.833-.834v-5a.833.833 0 00-.833-.833h-5a.833.833 0 00-.834.833v5c0 .46.373.834.834.834zm0-5.834h5v5h-5v-5zM16.667 17.497c.46 0 .833-.373.833-.834v-5a.833.833 0 00-.833-.833h-5a.833.833 0 00-.834.833v5c0 .46.373.834.834.834h5zm-5-5.834h5v5h-5v-5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "my-hub_svg__clip0_1614_19500"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgMyHub;